import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";

import CCADetails from "./CCADetails";
import ConstructionSiteRenderer from "./ConstructionSiteRenderer";

class ConstructionSite extends SmartModel {
	static STATUS_OPEN = 1;
	static STATUS_CLOSED_OK = 3;
	static STATUS_CLOSED_NCR = 4;
	static STATUS_ENDED_NCR = 5;
	static STATUS_ENDED_OK = 2;
	static STATUS_NCR_RUNNING = 6;
	static STATUS_NCR_ENDED = 7;
	static STATUS_NCR_CLOSED = 8;

	constructor(data) {
		super();

		this.applicatorTeamId = "";
		this.attachments = [];
		// this.ccaDetailsGuid = "";
		this.ccaDetails = {}; //Join field
		this.clientContactSource = "";
		this.clientGuid = "";
		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.endDate = "0000-00-00 00:00:00";
		this.expectedEndDate = "0000-00-00 00:00:00";


		this.quotationGuid = "";
		this.constructionSiteCardGuid = "";
		this.constructionSiteCardRegistry = "";
		this.constructionSiteFolderGuid = "";
		this.notComplianceReportGuid = "";
		this.projectFolderGuid = "";
		this.siteInfoSheetGuid = "";
		this.teamCloseDocumentGuid = "";
		this.visitGuid = "";

		this.extraData = {
			closeNotes: "",
			closeDocumentURL: "",
			closeUserGuid: "",
			quotationCCA: "",
			relatedGuids: {
				clientGuid: "",
				quotationGuid: "",
				constructionSiteCardGuid: "",
				constructioSiteFolderGuid: "",
				projectFolderGuid: "",
				siteInfoSheetGuid: "",
				teamCloseDocumentGuid: "",
				visitGuid: "",
			},
		};

		this.guid = "";
		this.latestFollowUp = "";

		this.newFollowUpCount = 0;
		this.notComplianceReportCount = 0;
		this.quotationExtraData = {};
		this.quotationLots = [];

		this.registry = {
			clientAddress: "",
			clientAddressAndCity: "",
			clientCity: "",
			clientCommoditySector: "",
			clientEMail: "",
			clientGuid: "",
			clientName: "",
			clientNationalLocationsCount: "",
			clientPersonInCharge: "",
			clientPersonInChargeRole: "",
			clientPersonInChargeMobile: "",
			clientProvince: "",
			clientRegion: "",
			clientZip: "",

			customerGuid: "",//Committente 
			customerName: "",//Committente 
			designerGuid: "",//Progettista
			designerName: "",//Progettista
			endUserGuid: "",//Utilizzatore
			endUserName: "",//Utilizzatore
			receiver: "",

			siteLocation: {
				address: "",
				buyers: "",
				city: "",
				constructionCompanies: "",
				designers: "",
				interventionAreas: "",
				logisticNotes: "",
				name: "",
				personInCharge: {
					name: "",
					eMail: "",
					phone: ""
				},
				possibleAggressionsAndInteractions: "",
				province: "",
				region: "",
				zip: "",
			},

			siteIPMPersonInCharge: "",
			sitePremiseDestinations: [],
			sitePremiseScope: "",

			sqMToBeRealized: 0,
			siteVisitDate: "0000-00-00 00:00:00",
			substrateType: "",
		};

		this.startDate = "0000-00-00 00:00:00";
		this.status = 0;//[1: Aperto e in corso, 2: Chiuso dall'agente, 3: Concluso con chiusura squadra, 4: Concluso con Non Conformità, 5: Chiuso con Non Conformità, 6: Cantiere NCR in corso, 7 Cantiere NCR chiuso, 8 Cantiere NCR concluso ]
		this.type = "";
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";
		this.userGuid = "";
		
		this.__endDate = "";
		this.__followUpList = [];
		this.__hasNewFollowUp = false;
		this.__hilited = false;
		this.__isUnderWarranty = false;
		//this.__notComplianceCount = 0;
		this.__render = true;
		this.__showAddClosingDocumentBtn = false;
		this.__showReplaceClosingDocumentBtn = false;
		this.__showCloseBtn = false;
		this.__statusCSSClass = "";
		this.__statusLabel = "";
		this.__warrantyMonths = 0;


		this.__reportData = {};

		if (data) {
			//Dave.Warn: Questo import non mantiene i valori di default espressi sopra, verifica perché e risolvi.
			this.import(data);
		}

		this.addRenderer(new ConstructionSiteRenderer(this));
	}

	evaluateSiteLocationLabel () {
		if (this.registry.siteLocation.name !== "") {
			this.__siteLocationLabel = this.registry.siteLocation.name;
		}
		else {
			this.__siteLocationLabel = "Sede Legale";
		}

		if (this.registry.siteLocation.interventionAreas !== "") {
			this.__siteLocationLabel += " - " + this.registry.siteLocation.interventionAreas;
		}
	}

	export() {
		var exportData = this.__export();

		//Dave.ToDO: Devo fare i metodi exportField come gli import
		exportData.endDate = moment.utc(this.endDate).format("YYYY-MM-DD HH:mm:ss");
		exportData.expectedEndDate = moment.utc(this.expectedEndDate).format("YYYY-MM-DD HH:mm:ss");
		exportData.startDate = moment.utc(this.startDate).format("YYYY-MM-DD HH:mm:ss");
		exportData.extraData = JSON.stringify(this.extraData);
		exportData.registry = JSON.stringify(this.registry);
		
		exportData.attachments = JSON.stringify(this.attachments);
		console.log("ConstructionSite.export", {exportData});
		return exportData;
	}

	evaluateApplicationTeamLabel () {
		const applicatorTeamList = Shark.get("applicatorTeamList");
		if (applicatorTeamList && applicatorTeamList.length > 0) {
			const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", this.applicatorTeamId);

			if (currApplicatorTeam) {
				this.__applicatorTeamName = currApplicatorTeam.name;
			}
		}
	}

	evaluateExtraDates () {
		if (this.quotationLots && this.quotationLots.length > 0) {
			const lotIndex = Utils.safp(this.quotationLots, "cscGuid", this.constructionSiteCardGuid, "index");

			if (lotIndex !== null && lotIndex > -1) {
				const currLot = this.quotationLots[lotIndex];

				if (currLot.multipleDates && currLot.multipleDates.length > 0) {
					this.__extraDates = [];

					currLot.multipleDates.forEach(item => {
						//Dave: questa cosa è da spostare altrove
						const applicatorTeamList = Shark.get("applicatorTeamList");
						const cloned = Object.assign({}, item);

						if (applicatorTeamList && applicatorTeamList.length > 0) {
							const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", item.applicatorTeamId);
				
							if (currApplicatorTeam) {
								cloned.__applicatorTeamName = currApplicatorTeam.name;
							}
						}

						if (typeof item.constructionEndDateTime.isValid === "undefined") {
							item.constructionEndDateTime = moment(item.constructionEndDateTime);
							item.constructionStartDateTime = moment(item.constructionStartDateTime);
						}
						
						cloned.__timeSpanEndLabel = item.constructionEndDateTime.format(Shark.get("dateHumanFormat"));
						cloned.__timeSpanStartLabel = item.constructionStartDateTime.format(Shark.get("dateHumanFormat"));
				
						this.__extraDates.push(cloned);
					});

					this.__hasExtraDates = this.__extraDates.length > 1;
				}
			}
		}
		else {
			if (this.quotationExtraData && this.quotationExtraData.confirmData && this.quotationExtraData.confirmData.timeSpanAndApplicatorTeam.extraDates) {
				this.__extraDates = [];

				this.quotationExtraData.confirmData.timeSpanAndApplicatorTeam.extraDates.forEach(item => {
					//Dave: questa cosa è da spostare altrove
					const applicatorTeamList = Shark.get("applicatorTeamList");
					const cloned = Object.assign({}, item);

					if (applicatorTeamList && applicatorTeamList.length > 0) {
						const currApplicatorTeam = Utils.safp(applicatorTeamList, "guid", item.applicatorTeamId);
			
						if (currApplicatorTeam) {
							cloned.__applicatorTeamName = currApplicatorTeam.name;
						}
					}

					if (typeof item.constructionEndDateTime.isValid === "undefined") {
						item.constructionEndDateTime = moment(item.constructionEndDateTime);
						item.constructionStartDateTime = moment(item.constructionStartDateTime);
					}
					
					cloned.__timeSpanEndLabel = item.constructionEndDateTime.format(Shark.get("dateHumanFormat"));
					cloned.__timeSpanStartLabel = item.constructionStartDateTime.format(Shark.get("dateHumanFormat"));
			
					this.__extraDates.push(cloned);
				});

				this.__hasExtraDates = this.__extraDates.length > 1;
			}
		}
	}

	import (data, options) {
		this.__import(data, options);

		if (this.importDateField("createdAt", data.createdAt)) {
			this.__createdAt = this.createdAt.format("YYYY-MM-DD");
			this.__createdAtLabel = this.createdAt.format("DD/MM/YYYY");
		}
		if (this.importDateField("endDate", data.endDate)) {
			this.__endDate = this.endDate.format("YYYY-MM-DD");
			this.__endDateLabel = this.endDate.format("DD/MM/YYYY");

			this.__warrantyMonths = moment().set({hour: 0, minute: 0, seconds: 0}).diff((this.endDate).clone().set({hour: 0, minute: 0, seconds: 0}), "M");
			this.__isUnderWarranty = moment().set({hour: 0, minute: 0, seconds: 0}).diff((this.endDate).clone().set({hour: 0, minute: 0, seconds: 0}), "M") < 24;
		}
		else {
			this.__endDateLabel = "Non concluso";
		}
		if (this.importDateField("expectedEndDate", data.expectedEndDate)) {
			this.__expectedEndDate = this.expectedEndDate.format("YYYY-MM-DD");
			this.__expectedEndDateLabel = this.expectedEndDate.format("DD/MM/YYYY");
		}

		if (typeof data.latestFollowUp === "string") {
			this.latestFollowUp = data.latestFollowUp;
		}
		this.importNumberField("newFollowUpCount", data.newFollowUpCount);
		this.importNumberField("notComplianceReportCount", data.notComplianceReportCount);

		if (this.importDateField("startDate", data.startDate)) {
			this.__startDate = this.startDate.format("YYYY-MM-DD");
			this.__startDateLabel = this.startDate.format("DD/MM/YYYY");
		}

		this.importNumberField("status", data.status);

		if (this.importDateField("updatedAt", data.updatedAt)) {
			this.__updatedAt = this.updatedAt.format("YYYY-MM-DD");
			this.__updatedAtLabel = this.updatedAt.format("DD/MM/YYYY - HH:mm");
		}

		this.__hasFollowUp = this.latestFollowUp !== "" || this.__followUpList.length > 0;
		this.__hasNewFollowUp = this.newFollowUpCount > 0;
		this.__status_ended = this.status === ConstructionSite.STATUS_ENDED_OK;
		this.__status_ncr_running = this.status === 6;

		this.__showAddClosingDocumentBtn = [ConstructionSite.STATUS_ENDED_OK, ConstructionSite.STATUS_ENDED_NCR, ConstructionSite.STATUS_NCR_ENDED].includes(this.status);
		this.__showReplaceClosingDocumentBtn = [ConstructionSite.STATUS_CLOSED_NCR, ConstructionSite.STATUS_CLOSED_OK, ConstructionSite.STATUS_NCR_CLOSED].includes(this.status);

		if (this.status === 4) {
			this.__statusCSSClass = " bg-danger text-light";
		}
		else if ([6, 7, 8].includes(this.status)) {
			this.__statusRowCSSClass = " cs-not-compliance-report-row";
		}
		this.__showCloseBtn = [ConstructionSite.STATUS_OPEN, ConstructionSite.STATUS_NCR_RUNNING].includes(this.status);

		// this.__reportData.agentName = this.registry.siteIPMPersonInCharge;
		// this.__reportData.province = this.registry.clientProvince;
		// this.__reportData.sector = this.registry.clientCommoditySector;

		const agentList = Shark.get("agentList");
		if (agentList) {
			const currAgent = Utils.safp(agentList, "guid", this.userGuid);
			if (currAgent) {
				this.__agentName = currAgent.__fullName;
			}
		}

		if (this.extraData.quotationCCA) {
			this.__ccaLabel = this.extraData.quotationCCA;
		}

		this.evaluateApplicationTeamLabel();

		if (typeof data.latestFollowUp === "string") {
			this.latestFollowUp = data.latestFollowUp;
			this.__hasFollowUp = this.latestFollowUp !== "" || this.__followUpList.length > 0;
		}

		// this.__typeLabel = this.type === "industrial" ? "Industriale" : (this.type === "outdoor" ? "Outdoor" : "N/D");
		this.__notComplianceReportCountLabel = [ConstructionSite.STATUS_NCR_RUNNING, ConstructionSite.STATUS_NCR_ENDED, ConstructionSite.STATUS_NCR_CLOSED].indexOf(this.status) === -1 ? this.notComplianceReportCount : "N/D";
		this.__statusLabel = Shark.get("constructionSiteStatusMap")[this.status];


		const contactSourceMap = Shark.get("contactSourceMap");
		this.__clientContactSourceLabel = contactSourceMap[this.clientContactSource];

		this.evaluateExtraDates();
		this.evaluateSiteLocationLabel();
		this.parseCloseNotes();
		this.parseQuotationExtraData();
		this.parseQuotationLots();
		this.parseRegistry();
		// this.__renderer.parseValue();
		
		this.parseCCADetails();
	}

	onDataChanged(data) {
		switch (data.property) {
			case "__endDate":
				this[data.property.substr(2)] = moment(data.newValue);
				this[data.property + "Label"] = this[data.property.substr(2)]._isValid ? this[data.property.substr(2)].format("DD/MM/YYYY") : "";
				break;
		}
	}

	parseCCADetails () {
		if (this?.ccaDetails?.cca) {
			this.ccaDetails = new CCADetails(this.ccaDetails);

			this.__hasExtraDates = false;

			if (this.ccaDetails.cca && this.ccaDetails.cca.trim() !== "") {
				this.__ccaLabel = this.ccaDetails.cca;
			}
			else {
				this.__ccaLabel = "";
			}

			if (this.ccaDetails.__timeSpanEnd && this.ccaDetails.__timeSpanEnd.trim() !== "") {
				this.__endDateLabel = this.ccaDetails.__timeSpanEndLabel;
			}

			if (this.ccaDetails.__timeSpanStart && this.ccaDetails.__timeSpanStart.trim() !== "") {
				this.__startDateLabel = this.ccaDetails.__timeSpanStartLabel;
			}
		}
	}

	parseCloseNotes() {
		this.__showReadMoreCloseNotesBtn = this.extraData.closeNotes.length > 35;
		this.__closeNotesAbstract = this.__showReadMoreCloseNotesBtn ? this.extraData.closeNotes.substr(0, 35) + "..." : this.extraData.closeNotes;
	}

	parseQuotationExtraData () {
		this.__presumedAmount = 0;

		if (this.quotationLots && this.quotationLots.length > 0) {
			const currLot = this.quotationLots.find(item => item.cscGuid === this.constructionSiteCardGuid);

			if (currLot) {
				this.__presumedAmount = currLot.expetedAmount;
			}
			else {
				this.__presumedAmount = 0;
			}
		}

		if (this.__presumedAmount === 0) {
			if (this.quotationExtraData && this.quotationExtraData.confirmData) {
				this.__presumedAmount = this.quotationExtraData.confirmData.presumedAmount;
			}
			else {
				this.__presumedAmount = 0;
			}
		}
	}

	parseQuotationLots () {
		if (this.quotationLots && this.quotationLots.length > 0) {
			const referenceLotIndex = Utils.safp(this.quotationLots, "cscGuid", this.constructionSiteCardGuid, "index");

			
			if (referenceLotIndex > -1) {
				this.__lotId = referenceLotIndex;
				
				if (this.quotationLots?.[referenceLotIndex]?.area) {
					const mq = parseFloat(this.quotationLots[referenceLotIndex].area);
					this.__reportData.area = isNaN(mq) ? this.quotationLots[referenceLotIndex].area.replace("NaN", "") : (Math.round(mq) !== mq ? mq.toFixed(2) : mq);
				}

				if (this.quotationLots.length === 1) {
					this.__lotIdLabel = "Lotto unico";
				}
				else {
					this.__lotIdLabel = "Lotto #" + (referenceLotIndex + 1);
				}
			}
			else {
				this.__lotId = -1;
				this.__lotIdLabel = "Lotto unico";
			}
		}
		else {
			this.__lotId = -1;
			this.__lotIdLabel = "Lotto unico";
		}
	}

	parseRegistry () {
		//Dave.ToDo: visto che questa cosa del registry c'è in tanti posti, presumo dovrebbe diventare un oggetto
		//  Diciamo una roba legata al "Progetto" (anche se ancora non esiste), che abbia un solo punto di salvataggio e gli altri lo leggono e basta
		if (this.registry) {
			const registry = this.registry;

			this.__receiverIsCustomer = registry.receiver === "customer";
			this.__receiverIsDesigner = registry.receiver === "designer";
			this.__receiverIsEndUser = registry.receiver === "endUser";
			
			// Dave: Questa roba del "_[role]Name" è tutta da uniformare e gestire.
			this.__customerName = registry.customerName;
			this.__designerName = registry.designerName;
			this.__endUserName = registry.endUserName;

			if (this.__customerName === "" && this.customer) {
				this.__customerName = this.customer.name;
			}
	
			if (this.__designerName === "" && this.designer) {
				this.__designerName = this.designer.name;
			}
	
			if (this.__endUserName === "" && this.endUser) {
				this.__endUserName = this.endUser.name;
			}
	
			switch (registry.receiver) {
				case "customer":
					this.__receiverNameLabel = registry.customerName || this.__customerName || registry.clientName;
					this.__receiverTypeLabel = "Committente";
					break;
				case "designer":
					this.__receiverNameLabel = registry.designerName || this.__designerName || registry.clientName;
					this.__receiverTypeLabel = "Progettista";
					break;
				case "endUser":
					this.__receiverNameLabel = registry.endUserName || this.__endUserName || registry.clientName;
					this.__receiverTypeLabel = "Utilizzatore Finale";
					break;
			}
	
			//Se c'è un committente è lui che va mostrato, se no si passa al progettista, se no all'utente finale (in teoria impossibile)
			if (this?.__customerName?.trim() !== "") {
				this.__receiverNameLabel = this.__customerName;
				this.__receiverCSSClass = "customer";
				this.__receiverTypeLabel = "Committente";
			}
			else if (this?.__designerName?.trim() !== "") {
				this.__receiverNameLabel = this.__designerName;
				this.__receiverCSSClass = "designer";
				this.__receiverTypeLabel = "Progettista";
			}
			else if (this?.__endUserName?.trim() !== "") {
				this.__receiverNameLabel = this.__endUserName;
				this.__receiverCSSClass = "endUser";
				this.__receiverTypeLabel = "Utilizzatore finale";
			}
		}
	}
}

Shark.registerModel("ConstructionSite", ConstructionSite);

export default ConstructionSite;